import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {role, roles} = api

/**
 * 查找角色
 */
export async function findRole(params) {
    return request({url: role, method: 'get', data: params,})
}

/**
 * 创建角色
 */
export async function createRole(params) {
    return request({url: roles, method: 'post', data: params,})
}

/**
 * 更新角色
 */
export async function updateRole(params) {
    return request({url: role, method: 'put', data: params,})
}

/**
 * 删除角色
 */
export async function deleteRole(params) {
    return request({url: role, method: 'delete', data: params,})
}


/**
 * 查找角色列表
 */
export async function findRoles(params) {
    return request({url: roles, method: 'get', data: params,})
}

/**
 * 删除角色
 */
export async function deleteRoles(params) {
    return request({url: role, method: 'delete', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/role.js